import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { Transit } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface UpdateTransitProps {
  transit: Partial<Transit>;
  refreshCustomerData?: boolean;
  overwriteTrace?: boolean;
}

export const useUpdateTransit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ transit, refreshCustomerData, overwriteTrace }: UpdateTransitProps): Promise<Transit> => {
      const { data } = await request({
        path: 'transits/update',
        method: 'PATCH',
        authenticate: true,
        dataObject: { transit, refreshCustomerData, overwriteTrace },
      });
      return data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['transit', data._id] });
      queryClient.invalidateQueries({ queryKey: ['transits'] });
      toast.success('Transit saved successfully!');
    },
    onError: (error) => {
      const originalError = (error as any).response?.data?.originalError;
      showErrorToast(error, originalError || `Error saving the transit!`);
    },
  });
};
